/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Help_Comfort_Temperature_UpdateInputs */



/**
* | output |
* | --- |
* | "Comfort temperature change" |
*
* @param {Users_Help_Comfort_Temperature_UpdateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const users_help_comfort_temperature_update = /** @type {((inputs?: Users_Help_Comfort_Temperature_UpdateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Help_Comfort_Temperature_UpdateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Comfort temperature change")
	return /** @type {LocalizedString} */ ("Changement de la température de confort")
});